import { Controller } from "@hotwired/stimulus"

// Config-driven calculator for the public /tools pages. Field inputs are read
// from the DOM by data-field-key; the formula key and output formatting come
// from the data-tool-calculator-config-value JSON. Runs entirely client-side.
const FORMULAS = {
  // Reorder point = (average daily usage x lead time) + safety stock
  reorder_point(i) {
    const leadTimeDemand = i.avg_daily_usage * i.lead_time
    return {
      lead_time_demand: leadTimeDemand,
      reorder_point: leadTimeDemand + i.safety_stock
    }
  },

  // Economic order quantity = sqrt(2 x annual demand x order cost / holding cost)
  eoq(i) {
    if (i.holding_cost <= 0 || i.annual_demand <= 0) {
      return { eoq: NaN, orders_per_year: NaN, annual_cost: NaN }
    }
    const eoq = Math.sqrt((2 * i.annual_demand * i.order_cost) / i.holding_cost)
    const ordersPerYear = i.annual_demand / eoq
    const annualCost = ordersPerYear * i.order_cost + (eoq / 2) * i.holding_cost
    return { eoq: eoq, orders_per_year: ordersPerYear, annual_cost: annualCost }
  }
}

export default class extends Controller {
  static targets = ["field", "output"]
  static values = { config: Object }

  connect() {
    this.compute()
  }

  compute() {
    const inputs = {}
    this.fieldTargets.forEach((el) => {
      const value = parseFloat(el.value)
      inputs[el.dataset.fieldKey] = Number.isFinite(value) ? value : 0
    })

    const formula = FORMULAS[this.configValue.formula]
    const results = formula ? formula(inputs) : {}
    const outputSpecs = this.configValue.outputs || []

    this.outputTargets.forEach((el) => {
      const spec = outputSpecs.find((o) => o.key === el.dataset.outputKey) || {}
      el.textContent = this.format(results[el.dataset.outputKey], spec)
    })
  }

  format(value, spec) {
    if (value == null || !Number.isFinite(value) || value < 0) return "—"

    const decimals = spec.decimals == null ? 0 : spec.decimals
    const number = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value)

    return `${spec.prefix || ""}${number}${spec.suffix ? " " + spec.suffix : ""}`
  }
}
